// Helper function to safely parse mood timestamp
export const parseMoodTimestamp = (mood) => {
  if (!mood || !mood.timestamp) return null;

  // Handle Firestore timestamp format (with seconds property)
  if (mood.timestamp.seconds) {
    return new Date(mood.timestamp.seconds * 1000);
  }

  // Handle regular Date object or timestamp string
  if (mood.timestamp instanceof Date) {
    return mood.timestamp;
  }

  // Handle timestamp string or number
  const date = new Date(mood.timestamp);
  if (isNaN(date.getTime())) {
    console.warn(
      "Invalid timestamp in mood:",
      mood.timestamp,
      "for mood:",
      mood
    );
    return null;
  }
  return date;
};

// Generate available periods from moods in descending chronological order
export const generateAvailablePeriods = (moods) => {
  if (!moods || moods.length === 0) return [];

  // Sort moods by timestamp desc, then map to Month Year, and uniq in order
  const sorted = [...moods].sort((a, b) => {
    const dateA = parseMoodTimestamp(a);
    const dateB = parseMoodTimestamp(b);
    if (!dateA || !dateB) return 0;
    return dateB.getTime() - dateA.getTime();
  });

  const seen = new Set();
  const periods = [];

  for (const mood of sorted) {
    const date = parseMoodTimestamp(mood);
    if (!date || isNaN(date.getTime())) continue; // Skip invalid dates

    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    const label = `${month} ${year}`;

    // Debug logging
    if (isNaN(year) || !month) {
      console.warn("Invalid date parsing result:", { mood, date, month, year });
      continue;
    }

    if (!seen.has(label)) {
      seen.add(label);
      periods.push(label);
    }
  }
  return periods;
};
